<script setup>
const props = defineProps(['movies']);
const emit = defineEmits(['select-movie']);
function handleSelectMovie(movieId) {
  emit('select-movie', movieId);
}
</script>
<template>
  <div class="movie-list-container">
    <div v-if="movies.length === 0" class="no-movies">
      <p>No movies found. <a href="#new-movie">Create your first movie</a> to get started!</p>
    </div>
    <div v-else class="movie-grid">
      <p>
        Get started by <a href="#new-movie">creating a movie.</a>
        or selecting one below
      </p>
      <div v-for="movie in movies" :key="movie.id" class="movie-card" @click="handleSelectMovie(movie.id)">
        <h3 class="movie-title">{{ movie.name || 'Untitled Movie' }}</h3>
        <p v-if="movie.description" class="movie-description">{{ movie.description }}</p>
        <div class="movie-meta">
          <span v-if="movie.createdAt" class="created-date"> Created: {{ new Date(movie.createdAt).toLocaleDateString() }} </span>
        </div>
      </div>
    </div>
  </div>
</template>
